import React from "react";
import { TbBellRinging, TbBuilding, TbCalendarEvent, TbCalendarOff, TbCalendarStats, TbCalendarTime, TbClockHour4, TbClockHour8, TbClockHour9, TbCode, TbCoffee, TbCurrencyRupee, TbGift, TbPencil, TbTimeDuration30, TbTrendingUp, TbUsers } from "react-icons/tb";
import {
  Box,
  Button,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import { SelectFieldMulti } from "../../../ppui/select-field-multi";
import { Snackbar } from "../../../ppui/snackbar";
import useCommonfn from "../../../utils/useCommonfn";
import { Card, CardHeading, OrganizationBx, OrganizationEmDetails } from "../../style";
import { BONUS_STATUS_FIELDS, EMP_SETUP_CONST } from "./benefit-constant";
import useBenifitService from "./use-benefit-service";


function OrganizationBenefits() {
  const { navigateToDashBoard } = useCommonfn();
  const {
    handleChangeFunction,
    onSubmit,
    errors,
    benifitData,
    createUpdateLoading,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    // handleCloseBenefitsModal,
    // handleOpenBenefitsModal,
    // openBenefitsModal,
    openBenefitsModalStep2,
    handleOpenBenefitsModalStep2,
    handleCloseBenefitsModalStep2,
    getProfileLoading,
    benefitViewData,
    empSetup,
    employmentSetupOnChngFn,
    OnBlureEmpSetup,
    empsetuperr,
  } = useBenifitService();

  if (getProfileLoading) {
    return <p>Benefit Loading...</p>;
  }

  return (
    <>
      {!benifitData?.org_id ? (
        <>
          <Typography variant="h5">Employment Setup</Typography>
          <Row rowGap>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectFieldMulti
                {...EMP_SETUP_CONST.employmentType}
                onChange={(e) => employmentSetupOnChngFn(e, "employmentType")}
                onBlur={(e) => OnBlureEmpSetup(e, "employmentType")}
                error={!!empsetuperr?.employmentType}
                helperText={empsetuperr?.employmentType}
                defaultValue={empSetup?.employmentType}
              />
            </Col>

            {/* <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...EMP_SETUP_CONST.isProvisionPeriod}
                onChange={(e) =>
                  employmentSetupOnChngFn(e, "isProvisionPeriod")
                }
                onBlur={(e) => OnBlureEmpSetup(e, "isProvisionPeriod")}
                defaultValue={empSetup?.isProvisionPeriod}
                error={!!empsetuperr?.isProvisionPeriod}
                helperText={empsetuperr?.isProvisionPeriod}
              />
            </Col> */}
            {empSetup?.employmentType.includes('probationary') && (
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...EMP_SETUP_CONST?.provisionDays}
                  onChange={(e) => employmentSetupOnChngFn(e, "provisionDays")}
                  onBlur={(e) => OnBlureEmpSetup(e, "provisionDays")}
                  valueSinc={!!empSetup?.provisionDays}
                  value={empSetup?.provisionDays}
                  error={!!empsetuperr?.provisionDays}
                  helperText={empsetuperr?.provisionDays}
                />
              </Col>
            )}

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...EMP_SETUP_CONST?.isNoticePeriod}
                onChange={(e) => employmentSetupOnChngFn(e, "isNoticePeriod")}
                onBlur={(e) => OnBlureEmpSetup(e, "isNoticePeriod")}
                defaultValue={empSetup?.isNoticePeriod}
                error={!!empsetuperr?.isNoticePeriod}
                helperText={empsetuperr?.isNoticePeriod}
              />
            </Col>
            {empSetup?.isNoticePeriod && (
              <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
                <InputField
                  {...EMP_SETUP_CONST?.noticeDays}
                  onChange={(e) => employmentSetupOnChngFn(e, "noticeDays")}
                  onBlur={(e) => OnBlureEmpSetup(e, "noticeDays")}
                  value={empSetup?.noticeDays}
                  error={!!empsetuperr?.noticeDays}
                  helperText={empsetuperr?.noticeDays}
                  valueSinc={!!empSetup?.noticeDays}
                />
              </Col>
            )}
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...EMP_SETUP_CONST?.prefix}
                onChange={(e) => employmentSetupOnChngFn(e, "prefix")}
                onBlur={(e) => OnBlureEmpSetup(e, "prefix")}
                value={empSetup?.prefix}
                error={!!empsetuperr?.prefix}
                helperText={empsetuperr?.prefix}
                valueSinc={!!empSetup?.prefix}
              />
            </Col>

            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...EMP_SETUP_CONST?.leave_staging}
                onChange={(e) => employmentSetupOnChngFn(e, "leave_staging")}
                onBlur={(e) => OnBlureEmpSetup(e, "leave_staging")}
                error={!!empsetuperr?.leave_staging}
                helperText={empsetuperr?.leave_staging}
                defaultValue={empSetup?.leave_staging}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...EMP_SETUP_CONST?.leave_type}
                onChange={(e) => employmentSetupOnChngFn(e, "leave_type")}
                onBlur={(e) => OnBlureEmpSetup(e, "leave_type")}
                error={!!empsetuperr?.leave_type}
                helperText={empsetuperr?.leave_type}
                defaultValue={empSetup?.leave_type}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectFieldMulti
                {...EMP_SETUP_CONST?.workMode}
                onChange={(e) => employmentSetupOnChngFn(e, "workMode")}
                onBlur={(e) => OnBlureEmpSetup(e, "workMode")}
                error={!!empsetuperr?.workMode}
                helperText={empsetuperr?.workMode}
                defaultValue={empSetup?.workMode}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <SelectField
                {...EMP_SETUP_CONST?.shiftManagement}
                onChange={(e) => employmentSetupOnChngFn(e, "shiftManagement")}
                onBlur={(e) => OnBlureEmpSetup(e, "shiftManagement")}
                error={!!empsetuperr?.shiftManagement}
                helperText={empsetuperr?.shiftManagement}
                defaultValue={empSetup?.shiftManagement}
                value={empSetup?.shiftManagement}
                disabled
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...EMP_SETUP_CONST?.loginTime}
                onChange={(e) => employmentSetupOnChngFn(e, "loginTime")}
                onBlur={(e) => OnBlureEmpSetup(e, "loginTime")}
                helperText={empsetuperr?.loginTime}
                error={!!empsetuperr?.loginTime}
                value={empSetup?.loginTime}
                valueSinc={!empSetup?.loginTime}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...EMP_SETUP_CONST?.logoutTime}
                onChange={(e) => employmentSetupOnChngFn(e, "logoutTime")}
                onBlur={(e) => OnBlureEmpSetup(e, "logoutTime")}
                helperText={empsetuperr?.logoutTime}
                error={!!empsetuperr?.logoutTime}
                value={empSetup?.logoutTime}
                valueSinc={!empSetup?.logoutTime}
              />
            </Col>
            <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
              <InputField
                {...EMP_SETUP_CONST?.breakTime}
                // prefix={"min"}
                onChange={(e) => employmentSetupOnChngFn(e, "breakTime")}
                onBlur={(e) => OnBlureEmpSetup(e, "breakTime")}
                helperText={empsetuperr?.breakTime}
                error={!!empsetuperr?.breakTime}
                value={empSetup?.breakTime}
                valueSinc={!!empSetup?.breakTime}
              />
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Benefits Details</Typography>
          <Row rowGap>
            {BONUS_STATUS_FIELDS.map((fieldProps) => {
              if (!errors[fieldProps?.name]) {
                fieldProps.error = false;
                fieldProps.helperText = null;
              } else {
                fieldProps.error = !!errors[fieldProps.name];
                fieldProps.helperText = errors[fieldProps.name];
              }

              fieldProps.value = benifitData[fieldProps.name];
              fieldProps.defaultValue = benifitData[fieldProps.name];
              fieldProps.valueSinc = benifitData[fieldProps.name];

              if (fieldProps.inputType === "selectField") {
                return (
                  <Col sm={12} md={6} lg={4} xl={3} key={fieldProps.name}>
                    <SelectField
                      {...fieldProps}
                      onChange={(newValue) =>
                        handleChangeFunction(
                          newValue,
                          fieldProps.name,
                          fieldProps.customOptions
                        )
                      }
                    />
                  </Col>
                );
              } else if (fieldProps.inputType == "dateField") {
                return (
                  <Col sm={12} md={6} lg={4} xl={3} key={fieldProps.name}>
                    <InputField
                      value={new Date(benifitData[fieldProps.name])}
                      fullWidth
                      {...fieldProps}
                      valueSinc
                      onChange={(e) =>
                        handleChangeFunction(e, null, fieldProps.customOptions)
                      }
                    />
                  </Col>
                );
              } else {
                return (
                  <Col sm={12} md={6} lg={4} xl={3} key={fieldProps.name}>
                    <InputField
                      {...fieldProps}
                      onChange={(e) =>
                        handleChangeFunction(e, null, fieldProps.customOptions)
                      }
                    />
                  </Col>
                );
              }
            })}
          </Row>

          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={navigateToDashBoard} variant="outlined">
              Cancel
            </Button>
            <Button
              loading={createUpdateLoading}
              color="primary"
              onClick={onSubmit}
              variant="contained"
            >
              Save
            </Button>
          </Flex>
        </>
      ) : (
        <>
          <Card>
            <CardHeading Divider>
              Organization Configurations

              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={handleOpenBenefitsModalStep2}
                variant="filled"
                shape="box"
              />
            </CardHeading>
            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbUsers /> {/*  Good for Employment Type */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employment Type
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.employmentType
                      ?.map((id) => {
                        const item = EMP_SETUP_CONST?.employmentType?.options?.find(
                          (obj) => obj?.id === id
                        );
                        return item ? item.name : null;
                      })
                      .filter((name) => name)
                      .join(", ")}
                  </Typography>
                </Box>
              </OrganizationBx>

              {benefitViewData?.provisionDays && (
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbCalendarTime /> {/* Good for Provision Days */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Provision Days
                    </Typography>
                    <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                      {benefitViewData?.provisionDays}
                    </Typography>
                  </Box>
                </OrganizationBx>
              )}

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBellRinging /> {/*  Good for Notice Period */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Notice Period
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.isNoticePeriod === true ? "Yes" : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>

              {benefitViewData?.noticeDays && (
                <OrganizationBx>
                  <Icon size={"lg"}>
                    <TbCalendarEvent /> {/* Good for Notice Days. */}
                  </Icon>
                  <Box>
                    <Typography variant="body1" mb={"0"} color="primary">
                      Notice Days
                    </Typography>
                    <Typography variant="body2"
                      mb={"0"}
                      color="dark"
                      colorVariant="light"
                      textCase="capitalize">
                      {benefitViewData?.noticeDays}
                    </Typography>
                  </Box>
                </OrganizationBx>
              )}

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCode />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Employee Prefix Code
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.prefix ? benefitViewData?.prefix : "-"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendarOff />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Weekly Off
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.leave_staging === true ? "Organization Label" : "Employee Label"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendarStats />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Leave Period
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.leave_type
                      ? benefitViewData?.leave_type === "calender_year" ? "Calendar Year" : "Financial Year"
                      : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuilding />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Work Location
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.workMode
                      ?.map((id) => {
                        const item = EMP_SETUP_CONST?.workMode?.options?.find(
                          (obj) => obj?.id === id
                        );
                        return item ? item.name : null;
                      })
                      .filter((name) => name)
                      .join(", ")}
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                <TbTimeDuration30 />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Shift Management 
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {!benefitViewData?.shiftManagement && "Not" } Available
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbClockHour4 />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                  Login Time
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.loginTime} hr
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbClockHour8 />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                  Logout Time
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.logoutTime} hr
                  </Typography>
                </Box>
              </OrganizationBx>
              
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCoffee />
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                  Break Time
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.breakTime} min
                  </Typography>
                </Box>
              </OrganizationBx>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCurrencyRupee /> {/* Good for Bonus Status */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Bonus Status
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.bonus_status === true ? "Yes" : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbGift /> {/*  Good for Ex Gratia */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Ex Gratia
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.ex_gratia === true ? "Yes" : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbTrendingUp /> {/* Good for Incentive Application */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Incentive Application
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.incentive_application === true ? "Yes" : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbClockHour9 /> {/* Good for OT (Overtime) Application */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    OT Application
                  </Typography>
                  <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                    {benefitViewData?.ot_application === true ? "Yes" : "No"}
                  </Typography>
                </Box>
              </OrganizationBx>
            </OrganizationEmDetails>
          </Card>

        </>
      )}

      {/* <Dialog
        title="Update Organization Benefits Details"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openBenefitsModal}
        onClose={handleCloseBenefitsModal}
        onSubmit={() => onSubmit(handleCloseBenefitsModal)}
        btnLoading={createUpdateLoading}
        separator
      >
        <Row rowGap>
          {BONUS_STATUS_FIELDS.map((fieldProps) => {
            if (!errors[fieldProps.name]) {
              fieldProps.error = false;
              fieldProps.helperText = null;
            } else {
              fieldProps.error = !!errors[fieldProps.name];
              fieldProps.helperText = errors[fieldProps.name];
            }

            fieldProps.value = benifitData[fieldProps.name];
            fieldProps.defaultValue = benifitData[fieldProps.name];
            fieldProps.valueSinc = benifitData[fieldProps.name];

            if (fieldProps.inputType === "selectField") {
              return (
                <Col sm={12} md={6} key={fieldProps.name}>
                  <SelectField
                    {...fieldProps}
                    onChange={(newValue) =>
                      handleChangeFunction(
                        newValue,
                        fieldProps.name,
                        fieldProps.customOptions
                      )
                    }
                  />
                </Col>
              );
            } else if (fieldProps.inputType == "dateField") {
              return (
                <Col sm={12} md={6} key={fieldProps.name}>
                  <InputField
                    value={new Date(benifitData[fieldProps.name])}
                    fullWidth
                    {...fieldProps}
                    valueSinc
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            } else {
              return (
                <Col sm={12} md={6} key={fieldProps.name}>
                  <InputField
                    {...fieldProps}
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            }
          })}
        </Row>
      </Dialog> */}

      <Dialog
        title="Organization Configurations"
        closeButton={true}
        fullWidth
        maxWidth="md"
        buttonName={"Update"}
        open={openBenefitsModalStep2}
        onClose={handleCloseBenefitsModalStep2}
        onSubmit={() => onSubmit(handleCloseBenefitsModalStep2)}
        btnLoading={createUpdateLoading}
        separator
        bodyScroll={true}
      >
        <Row rowGap>
          <Col sm={12} md={6} xl={4}>
            <SelectFieldMulti
              {...EMP_SETUP_CONST.employmentType}
              onChange={(e) => employmentSetupOnChngFn(e, "employmentType")}
              onBlur={(e) => OnBlureEmpSetup(e, "employmentType")}
              error={!!empsetuperr?.employmentType}
              helperText={empsetuperr?.employmentType}
              defaultValue={empSetup?.employmentType}
            />
          </Col>

          <>

            {empSetup?.employmentType?.includes("probationary") && (
              <Col sm={12} md={6} xl={4}>
                <InputField
                  {...EMP_SETUP_CONST?.provisionDays}
                  onChange={(e) =>
                    employmentSetupOnChngFn(e, "provisionDays")
                  }
                  onBlur={(e) => OnBlureEmpSetup(e, "provisionDays")}
                  valueSinc={!!empSetup?.provisionDays}
                  value={empSetup?.provisionDays}
                  error={!!empsetuperr?.provisionDays}
                  helperText={empsetuperr?.provisionDays}
                />
              </Col>
            )}

            <Col sm={12} md={6} xl={4}>
              <SelectField
                {...EMP_SETUP_CONST?.isNoticePeriod}
                onChange={(e) =>
                  employmentSetupOnChngFn(e, "isNoticePeriod")
                }
                onBlur={(e) => OnBlureEmpSetup(e, "isNoticePeriod")}
                defaultValue={empSetup?.isNoticePeriod}
                error={!!empsetuperr?.isNoticePeriod}
                helperText={empsetuperr?.isNoticePeriod}
              />
            </Col>
            {empSetup?.isNoticePeriod && (
              <Col sm={12} md={6} xl={4}>
                <InputField
                  {...EMP_SETUP_CONST?.noticeDays}
                  onChange={(e) =>
                    employmentSetupOnChngFn(e, "noticeDays")
                  }
                  onBlur={(e) => OnBlureEmpSetup(e, "noticeDays")}
                  value={empSetup?.noticeDays}
                  error={!!empsetuperr?.noticeDays}
                  helperText={empsetuperr?.noticeDays}
                  valueSinc={!!empSetup?.noticeDays}
                />
              </Col>
            )}
          </>

          <Col sm={12} md={6} xl={4}>
            <InputField
              {...EMP_SETUP_CONST?.prefix}
              onChange={(e) => employmentSetupOnChngFn(e, "prefix")}
              onBlur={(e) => OnBlureEmpSetup(e, "prefix")}
              value={empSetup?.prefix}
              error={!!empsetuperr?.prefix}
              helperText={empsetuperr?.prefix}
              disabled
              valueSinc={!!empSetup?.prefix}
            />
          </Col>

          <Col sm={12} md={6} xl={4}>
            <SelectField
              {...EMP_SETUP_CONST?.leave_staging}
              onChange={(e) => employmentSetupOnChngFn(e, "leave_staging")}
              onBlur={(e) => OnBlureEmpSetup(e, "leave_staging")}
              error={!!empsetuperr?.leave_staging}
              helperText={empsetuperr?.leave_staging}
              defaultValue={empSetup?.leave_staging}
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <SelectField
              {...EMP_SETUP_CONST?.leave_type}
              onChange={(e) => employmentSetupOnChngFn(e, "leave_type")}
              onBlur={(e) => OnBlureEmpSetup(e, "leave_type")}
              error={!!empsetuperr?.leave_type}
              helperText={empsetuperr?.leave_type}
              defaultValue={empSetup?.leave_type}
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <SelectFieldMulti
              {...EMP_SETUP_CONST?.workMode}
              onChange={(e) => employmentSetupOnChngFn(e, "workMode")}
              onBlur={(e) => OnBlureEmpSetup(e, "workMode")}
              error={!!empsetuperr?.workMode}
              helperText={empsetuperr?.workMode}
              defaultValue={empSetup?.workMode}
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <SelectField
              {...EMP_SETUP_CONST?.shiftManagement}
              onChange={(e) => employmentSetupOnChngFn(e, "shiftManagement")}
              onBlur={(e) => OnBlureEmpSetup(e, "shiftManagement")}
              error={!!empsetuperr?.shiftManagement}
              helperText={empsetuperr?.shiftManagement}
              defaultValue={empSetup?.shiftManagement}
              value={empSetup?.shiftManagement}
              disabled
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <InputField
              {...EMP_SETUP_CONST?.loginTime}
              onChange={(e) => employmentSetupOnChngFn(e, "loginTime")}
              onBlur={(e) => OnBlureEmpSetup(e, "loginTime")}
              helperText={empsetuperr?.loginTime}
              error={!!empsetuperr?.loginTime}
              value={empSetup?.loginTime}
              valueSinc={!!empSetup?.loginTime}
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <InputField
              {...EMP_SETUP_CONST?.logoutTime}
              onChange={(e) => employmentSetupOnChngFn(e, "logoutTime")}
              onBlur={(e) => OnBlureEmpSetup(e, "logoutTime")}
              helperText={empsetuperr?.logoutTime}
              error={!!empsetuperr?.logoutTime}
              value={empSetup?.logoutTime}
              valueSinc={!!empSetup?.logoutTime}
            />
          </Col>
          <Col sm={12} md={6} xl={4}>
            <InputField
              {...EMP_SETUP_CONST?.breakTime}
              // prefix={"min"}
              onChange={(e) => employmentSetupOnChngFn(e, "breakTime")}
              onBlur={(e) => OnBlureEmpSetup(e, "breakTime")}
              helperText={empsetuperr?.breakTime}
              error={!!empsetuperr?.breakTime}
              value={empSetup?.breakTime}
              valueSinc={!!empSetup?.breakTime}
            />
          </Col>
          {BONUS_STATUS_FIELDS.map((fieldProps) => {
            if (!errors[fieldProps.name]) {
              fieldProps.error = false;
              fieldProps.helperText = null;
            } else {
              fieldProps.error = !!errors[fieldProps.name];
              fieldProps.helperText = errors[fieldProps.name];
            }

            fieldProps.value = benifitData[fieldProps.name];
            fieldProps.defaultValue = benifitData[fieldProps.name];
            fieldProps.valueSinc = benifitData[fieldProps.name];

            if (fieldProps.inputType === "selectField") {
              return (
                <Col sm={12} md={6} xl={4} key={fieldProps.name}>
                  <SelectField
                    {...fieldProps}
                    onChange={(newValue) =>
                      handleChangeFunction(
                        newValue,
                        fieldProps.name,
                        fieldProps.customOptions
                      )
                    }
                  />
                </Col>
              );
            } else if (fieldProps.inputType == "dateField") {
              return (
                <Col sm={12} md={6} xl={4} key={fieldProps.name}>
                  <InputField
                    value={new Date(benifitData[fieldProps.name])}
                    fullWidth
                    {...fieldProps}
                    valueSinc
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            } else {
              return (
                <Col sm={12} md={6} xl={4} key={fieldProps.name}>
                  <InputField
                    {...fieldProps}
                    onChange={(e) =>
                      handleChangeFunction(e, null, fieldProps.customOptions)
                    }
                  />
                </Col>
              );
            }
          })}
        </Row>
      </Dialog>

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default OrganizationBenefits;
